// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"913e5443","771":"e2f0600b","879":"0a570acd"}[chunkId] + ".chunk.js";
};